<template>
<!-- 결제 예스코인 컴포넌트 -->
    <div class="compo-form-item">
        <div class="compo-form-name">
            <label @click.prevent="toggleInfoBox" for="compo-form-title" class="compo-form-title">예스코인 <IconInfo></IconInfo></label>
            <button type="button" @click="showChargingLayerPopup" class="btn-s" :class="{'btn-p': balanceAfterPaymentInNum < 0}">충전하기</button>
        </div>
        <!-- 안내 문구 박스 -->
        <div v-show="activeInfo" class="info-box info-box__yescoin position-absolute">
            <IconClose @click.native="closeInfoBox" aria-label="닫기"></IconClose>
            <ul class="info">
                <li class="info-li"><span>쿠폰 주문 시 <strong>예스코인 결제만 가능</strong>하며 ‘충전하기’ 버튼을 통해 충전 후 결제하실 수 있습니다.</span></li>
            </ul>
        </div>
        <div class="compo-form-body">
            <table class="key-value">
                <tr>
                    <th>현재 예스코인</th>
                    <td>{{yescoinRemainAmtInNum.toLocaleString()}} 원</td>
                </tr>
                <tr>
                    <th>총 결제 금액</th>
                    <td>- {{paymentPriceInNum.toLocaleString()}} 원</td>
                </tr>
                <template v-if="balanceAfterPaymentInNum >= 0">
                <tr>
                    <th>결제 후 예스코인</th>
                    <td>{{balanceAfterPaymentInNum.toLocaleString()}} 원</td>
                </tr>
                </template>
            </table>
            <template v-if="balanceAfterPaymentInNum < 0">
                <p class="color-warning">예스코인 {{Math.abs(balanceAfterPaymentInNum).toLocaleString()}}원 부족</p>
            </template>
        </div>
    </div>
</template>

<script>
import { uncomma } from '@/util';

export default {
    components: {
        IconInfo: () => import('@/components/svg-icon/IconInfo.vue'),       // 인포메이션 아이콘
        IconClose: () => import('@/components/svg-icon/IconClose.vue'),     // 닫기 아이콘
    },

    props:{
        productItem : {     // 상품 정보, 예스코인 잔액 포함된 객체
            type: Object,
            required: true
        },
        paymentPrice : {    // 결제 금액
            type: Number,
            required: true
        },
    },

    data() {
        return {
            activeInfo: false,          // 인포박스 노출 여부
        }
    },

    computed: {
        // 예스코인 잔액 (타입: 숫자 In Number Type)
        yescoinRemainAmtInNum(){
            return Number(uncomma(this.productItem.yescoinRemainAmt));
        },

        // 결제 금액 (타입: 숫자 In Number Type)
        paymentPriceInNum(){
            return Number(uncomma(this.paymentPrice));
        },

        // 결제 후 예스코인 (타입: 숫자 In Number Type)
        balanceAfterPaymentInNum(){ 
            return this.yescoinRemainAmtInNum - this.paymentPriceInNum;
        },

        // 예스코인으로 결제 가능 여부
        isAvailableYescoinForPayment(){
            return this.balanceAfterPaymentInNum < 0 ? false : true;
        }
    },

    mounted(){
        this.setVuexIsAvailableYescoinForPayment();
    },

    watch: {
        isAvailableYescoinForPayment(){
            this.setVuexIsAvailableYescoinForPayment();
        }
    },

    methods: {

        // 충전 팝업 컴포넌트 노출
        showChargingLayerPopup(){
            this.$store.commit('modalStore/setVisibleChargingLayerPopup', true);
        },

        // 결제 가능 여부 Store 등록
        setVuexIsAvailableYescoinForPayment(){
            this.$store.commit('setVuexIsAvailableYescoinForPayment', this.isAvailableYescoinForPayment);
        },               
        
        // 인포박스 노출
        toggleInfoBox(){
            this.activeInfo = !this.activeInfo;
        },

        // 인포박스 닫기
        closeInfoBox(){
            this.activeInfo = false;
        },
    }
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/order.scss';
</style>